import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/toxicology/nitrosamine-risk-assessment")({
  beforeLoad: () => { throw redirect({ href: "/en/services/regulatory-toxicology/nitrosamine-risk-assessment", statusCode: 301 }); },
});
